import Marquee from "react-fast-marquee";
import { useI18n } from "../../lib/i18n";

export default function EditorialMarquee() {
    const { t } = useI18n();
    const items = t.marquee;
    return (
        <section
            className="relative py-10 md:py-14 border-y border-white/[0.06] bg-[#070707] overflow-hidden"
            data-testid="marquee-section"
        >
            <Marquee gradient={false} speed={38} pauseOnHover>
                {items.map((label, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-14 pr-14 font-heading text-5xl md:text-7xl tracking-[-0.02em] font-light"
                    >
                        <span
                            className={
                                i % 3 === 1 ? "text-[#E55B13]" : "stroke-text"
                            }
                        >
                            {label}
                        </span>
                        <span className="text-white/15 text-4xl md:text-5xl">
                            ✦
                        </span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
